import React from 'react';
export function PricingSection() {
  return <section id="pricing" aria-label="Precios y ofertas" className="bg-brand-card min-h-[100dvh] md:min-h-0 py-4 md:py-24 px-4 border-t border-brand-border flex flex-col justify-center" data-id="element-181">
      <div className="max-w-xl mx-auto w-full flex-1 md:flex-none flex flex-col justify-center" data-id="element-182">
        <div className="text-center mb-4 md:mb-10" data-id="element-183">
          <h2 className="text-2xl md:text-5xl font-heading font-bold text-white mb-1 md:mb-3" data-id="element-184">
            OFERTA ÚNICA —{' '}
            <span className="text-brand-accent" data-id="element-185">SOLO POR HOY</span>
          </h2>
        </div>

        <div className="bg-brand-dark rounded-2xl p-5 md:p-8 border-2 border-brand-accent shadow-xl relative overflow-hidden flex flex-col flex-1 md:flex-none" data-id="element-186">
          <div className="absolute top-0 right-0 bg-brand-accent text-brand-dark font-black text-xs px-4 py-1 rounded-bl-xl uppercase tracking-wider" data-id="element-187">
            ⭐ OFERTA TODO INCLUIDO
          </div>

          <div className="text-center mb-4 md:mb-8 pt-4" data-id="element-188">
            <h3 className="text-xl md:text-3xl font-heading font-bold text-white mb-1 md:mb-2" data-id="element-189">
              📘 MEGAPACK SOCIALES PRIMARIA COMPLETA
            </h3>
            <p className="text-white/70 text-xs md:text-base" data-id="element-190">
              6 tomos + 6 bonos estratégicos + Sistema de Gestión Docente
            </p>
          </div>

          <div className="order-first md:order-last border-b md:border-b-0 md:border-t border-brand-border pb-4 md:pb-0 md:pt-6 mb-4 md:mb-0" data-id="element-191">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 md:gap-y-3" data-id="element-192">
              {['6 Tomos completos (1° a 6°)', '+360 páginas de contenido', 'Solucionario completo en cada tomo', '6 Bonos estratégicos', 'Sistema de Gestión Docente', 'Acceso inmediato en PDF'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-193">
                  <span className="text-brand-accent text-sm mt-0.5" aria-hidden="true" data-id="element-194">
                    ✓
                  </span>
                  <span className="text-white/80 text-sm font-medium" data-id="element-195">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="mt-auto md:mt-0" data-id="element-196">
            <div className="text-center mb-4 md:mb-8" data-id="element-197">
              <div className="text-white/50 line-through text-base md:text-lg mb-1" data-id="element-198">
                Valor real: $71.000 ARS
              </div>
              <div className="text-4xl md:text-6xl font-black text-brand-accent" data-id="element-199">
                $19.990 <span className="text-xl md:text-3xl" data-id="element-200">ARS</span>
              </div>
            </div>

            <button onClick={() => window.open('https://www.profepack.com/cart/48113651515648:1', '_blank')} aria-label="Comprar MegaPack Sociales Primaria Completa por 19990 ARS" className="w-full bg-brand-accent hover:bg-brand-accent-dim text-brand-dark font-black text-lg md:text-xl py-4 md:py-6 rounded-2xl transition-colors flex items-center justify-center gap-2 active:scale-[0.98]" data-id="element-201">
              → QUIERO MI PROFEPACK SOCIALES
            </button>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-white/60 font-medium text-xs md:text-sm mt-4 md:mt-8" data-id="element-202">
          <span data-id="element-203">🔒 Pago seguro</span>
          <span data-id="element-204">⚡ Acceso en 5 min</span>
          <span data-id="element-205">🛡️ Garantía 7 días</span>
          <span data-id="element-206">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}